export default __webpack_public_path__ + "bff444dd9b24143778fae30fb5dbafe7.png";